export const parseInvalidAttributes = (flatObject, content) => {
  try {
    flatObject = flatObject.sort((a, b) => b.localeCompare(a))

    for (let i = 0; i < flatObject.length; i++) {
      let key = flatObject[i]
      let regex = new RegExp(`{{\\s*${key}\\s*}(?!})`, "g")
      content = content.replaceAll(regex, `{{${key}}}`)

      let regex2 = new RegExp(`(?<!{){\\s*${key}\\s*}}`, "g")
      content = content.replaceAll(regex2, `{{${key}}}`)

      content = checkEmptyTrailingCurly(flatObject, content, key)
      content = checkEmptyLeadingCurly(flatObject, content, key)
    }

    return content
  } catch (error) {
    console.error(error)
    throw error
  }
}

const checkEmptyLeadingCurly = (flatObject, content, key) => {
  try {
    let incompleteRegex = new RegExp(`(?<!{{)${key}}}(?!})`, "g")

    let match
    while ((match = incompleteRegex.exec(content)) !== null) {
      let key = match[0]
      let currentIndex = match.index

      // console.log(key, "key")

      let replaceContent = key.replace("}}", "")

      // console.log(replaceContent, "replaceContent")

      let filterArr = flatObject.filter((entry) => entry.startsWith(replaceContent) && entry != replaceContent)

      // console.log(filterArr, "filterArr")

      let isMatched = checkWithOtherKeys(filterArr, content, currentIndex)

      if (!isMatched) {
        content = content.slice(0, currentIndex) + content.slice(currentIndex).replace(key, `{{${key}`)
      }

      // console.log(content)
    }

    return content
  } catch (error) {
    throw error
  }
}

const checkEmptyTrailingCurly = (flatObject, content, key) => {
  try {
    let incompleteRegex = new RegExp(`{{\\s*${key}(?!\\s*}})`, "g")

    let match
    while ((match = incompleteRegex.exec(content)) !== null) {
      // console.log(`key: ${match[0]}; Index: ${match.index}`)

      let key = match[0]
      let currentIndex = match.index

      let replaceContent = key.replace("{{", "")

      let filterArr = flatObject.filter((entry) => entry.startsWith(replaceContent) && entry != replaceContent)

      // console.log(filterArr, "filterArr")

      let isMatched = checkWithOtherKeys(filterArr, content, currentIndex)

      if (!isMatched) {
        // console.log(isMatched, key, "after checking with other keys")

        content = content.slice(0, currentIndex) + content.slice(currentIndex).replace(key, `${key}}}`)
      }

      // console.log(content)
    }

    return content
  } catch (error) {
    throw error
  }
}

const checkWithOtherKeys = (filterArr, content, currentIndex) => {
  let isMatched = false
  for (let i = 0; i < filterArr.length; i++) {
    let regex = new RegExp(`{{\\s*${filterArr[i]}\\s*}}`, "g")

    // isMatched = regex.test(content);

    let match
    while ((match = regex.exec(content)) !== null) {
      if (currentIndex == match.index) {
        // console.log("matched")
        isMatched = true
        break
      } else {
        // console.log(currentIndex, match.index, "isMatched breaks")
        isMatched = false
      }
    }

    if (isMatched) break
  }

  // console.log(isMatched)
  return isMatched
}
